import styled from 'styled-components';

const SearchBarContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--clr-warm-white, #fefcf9);
  border-top: 1px solid var(--clr-beige, #e8ddd3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideDown 0.25s ease;
  z-index: 100;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .search-form {
    max-width: 640px;
    margin: 0 auto;
    padding: 1rem 1.25rem;
  }

  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .search-input-icon {
    position: absolute;
    left: 1rem;
    color: var(--clr-charcoal-light, #777);
    font-size: 0.9rem;
    pointer-events: none;
    z-index: 1;
  }
  [dir='rtl'] & .search-input-icon {
    left: auto;
    right: 1rem;
  }

  .search-input-wrapper input {
    width: 100%;
    padding: 0.85rem 2.75rem;
    border: 2px solid var(--clr-beige, #e8ddd3);
    border-radius: 999px;
    font-family: var(--font-body, 'Inter', sans-serif);
    font-size: 0.95rem;
    background: var(--clr-background, #f8f5f0);
    color: var(--clr-charcoal, #2b2b2b);
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
  .search-input-wrapper input:focus {
    border-color: var(--clr-olive, #5a6e3a);
    box-shadow: 0 0 0 3px hsla(85, 30%, 32%, 0.1);
  }
  .search-input-wrapper input::placeholder {
    color: var(--clr-charcoal-light, #999);
    opacity: 0.7;
  }

  .clear-btn {
    position: absolute;
    right: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: var(--clr-charcoal-light, #999);
    transition: all 0.2s ease;
  }
  [dir='rtl'] & .clear-btn {
    right: auto;
    left: 0.75rem;
  }
  .clear-btn:hover {
    background: hsla(0, 0%, 0%, 0.05);
    color: var(--clr-charcoal, #2b2b2b);
  }

  /* Suggestions Dropdown */
  .suggestions-dropdown {
    max-width: 640px;
    margin: 0 auto;
    padding: 0 1.25rem 0.75rem;
    max-height: 380px;
    overflow-y: auto;
  }

  .suggestion-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.6rem 0.75rem;
    background: transparent;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.15s ease;
    text-align: left;
    text-decoration: none;
  }
  [dir='rtl'] & .suggestion-item {
    text-align: right;
  }
  .suggestion-item:hover,
  .suggestion-item.active {
    background: hsla(85, 30%, 32%, 0.06);
  }

  .suggestion-image {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    background: var(--clr-beige, #f0ebe4);
  }
  .suggestion-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .suggestion-info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    flex: 1;
    min-width: 0;
  }

  .suggestion-name {
    font-family: var(--font-body, 'Inter', sans-serif);
    font-size: 0.88rem;
    font-weight: 500;
    color: var(--clr-charcoal, #2b2b2b);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .suggestion-name mark {
    background: hsla(85, 50%, 50%, 0.2);
    color: var(--clr-olive, #5a6e3a);
    font-weight: 600;
    border-radius: 2px;
    padding: 0 1px;
  }

  .suggestion-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.78rem;
  }

  .suggestion-category {
    color: var(--clr-charcoal-light, #999);
    text-transform: capitalize;
  }

  .suggestion-price {
    font-weight: 600;
    color: var(--clr-olive, #5a6e3a);
  }
  .original-price {
    text-decoration: line-through;
    color: var(--clr-charcoal-light, #999);
    font-weight: 400;
    margin-right: 0.35rem;
    font-size: 0.75rem;
  }
  .sale-price {
    color: #c0392b;
    font-weight: 600;
  }

  .suggestion-arrow {
    flex-shrink: 0;
    color: var(--clr-charcoal-light, #ccc);
    font-size: 0.7rem;
    opacity: 0;
    transition: opacity 0.15s ease;
  }
  .suggestion-item:hover .suggestion-arrow,
  .suggestion-item.active .suggestion-arrow {
    opacity: 1;
  }

  /* View all button */
  .view-all-btn {
    display: block;
    width: 100%;
    padding: 0.7rem 0.75rem;
    margin-top: 0.25rem;
    background: transparent;
    border: none;
    border-top: 1px solid var(--clr-beige, #e8ddd3);
    cursor: pointer;
    font-family: var(--font-body, 'Inter', sans-serif);
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--clr-olive, #5a6e3a);
    text-align: center;
    transition: background 0.15s ease;
    border-radius: 0 0 10px 10px;
  }
  .view-all-btn:hover,
  .view-all-btn.active {
    background: hsla(85, 30%, 32%, 0.06);
  }

  /* Loading */
  .suggestion-loading {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
  }
  .loading-dots {
    display: flex;
    gap: 4px;
  }
  .loading-dots span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--clr-olive, #5a6e3a);
    animation: bounce 1.2s infinite ease-in-out;
  }
  .loading-dots span:nth-child(1) { animation-delay: 0s; }
  .loading-dots span:nth-child(2) { animation-delay: 0.15s; }
  .loading-dots span:nth-child(3) { animation-delay: 0.3s; }
  @keyframes bounce {
    0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
    40% { opacity: 1; transform: scale(1); }
  }

  /* No results */
  .no-results {
    text-align: center;
    padding: 1.25rem 0;
    font-family: var(--font-body, 'Inter', sans-serif);
    font-size: 0.88rem;
    color: var(--clr-charcoal-light, #999);
  }

  /* Scrollbar styling */
  .suggestions-dropdown::-webkit-scrollbar {
    width: 4px;
  }
  .suggestions-dropdown::-webkit-scrollbar-track {
    background: transparent;
  }
  .suggestions-dropdown::-webkit-scrollbar-thumb {
    background: var(--clr-beige, #e8ddd3);
    border-radius: 4px;
  }

  /* Mobile responsiveness */
  @media (max-width: 767px) {
    .search-form {
      padding: 0.75rem 1rem;
    }
    .search-input-wrapper input {
      padding: 0.75rem 2.5rem;
      font-size: 0.9rem;
    }
    .suggestions-dropdown {
      padding: 0 1rem 0.5rem;
      max-height: 300px;
    }
    .suggestion-image {
      width: 38px;
      height: 38px;
    }
    .suggestion-name {
      font-size: 0.84rem;
    }
  }
`;

export default SearchBarContainer;
